import { render, staticRenderFns } from "./KwitansiReport.vue?vue&type=template&id=631077bc&scoped=true&"
import script from "./KwitansiReport.vue?vue&type=script&lang=js&"
export * from "./KwitansiReport.vue?vue&type=script&lang=js&"
import style0 from "./KwitansiReport.vue?vue&type=style&index=0&id=631077bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631077bc",
  null
  
)

export default component.exports